/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { PatchUsersPreferencesTechnicalSettingsOptions, PatchUsersPreferencesTechnicalSettingsResponses } from '../types/PatchUsersPreferencesTechnicalSettings'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /users/preferences/technical-settings/}
 */
export function patchUsersPreferencesTechnicalSettings<ThrowOnError extends boolean = true>(options: Options<PatchUsersPreferencesTechnicalSettingsOptions, ThrowOnError>): Unwrappable<RequestResult<PatchUsersPreferencesTechnicalSettingsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'PATCH', url: '/users/preferences/technical-settings/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<PatchUsersPreferencesTechnicalSettingsResponses, ThrowOnError>>)
}
